import { tokens } from "@opendoor/tokens-studio/dist/bricks-next/tokens/Components";
import { isKeyOfObject } from "../../../helpers/utils";
import { Box } from "../../Box";
import { useCheckInputLabel } from "../../shared/InputLabelContext";
import { Text } from "../../Text";
import { jsx, jsxs } from "react/jsx-runtime";
const { textInput: textInputTokens } = tokens, InputLabel = ({
  size,
  title,
  supportText,
  id,
  required,
  state
}) => (useCheckInputLabel(title), title ? /* @__PURE__ */ jsxs(Box, { gap: textInputTokens.padding.gap.titleAndSupport.default, children: [
  /* @__PURE__ */ jsxs(
    Text,
    {
      tag: "label",
      htmlFor: id,
      typography: textInputTokens.typography.fieldTitle[size],
      color: isKeyOfObject(state, textInputTokens.color.content.fieldTitle.state) ? textInputTokens.color.content.fieldTitle.state[state] : textInputTokens.color.content.fieldTitle.default,
      children: [
        title,
        required ? " *" : ""
      ]
    }
  ),
  !!supportText && /* @__PURE__ */ jsx(
    Text,
    {
      tag: "span",
      typography: textInputTokens.typography.supportText.default,
      color: isKeyOfObject(state, textInputTokens.color.content.supportText.state) ? textInputTokens.color.content.supportText.state[state] : textInputTokens.color.content.supportText.default,
      children: supportText
    }
  )
] }) : null);
export {
  InputLabel
};
